import { render, staticRenderFns } from "./bottom1.vue?vue&type=template&id=67b836d7&scoped=true"
import script from "./bottom1.vue?vue&type=script&lang=js"
export * from "./bottom1.vue?vue&type=script&lang=js"
import style0 from "./bottom1.vue?vue&type=style&index=0&id=67b836d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b836d7",
  null
  
)

export default component.exports